import { Component, OnInit } from '@angular/core'
import { AppState } from './store/models/app-state'
import { Store, select } from '@ngrx/store'
import { Observable, merge } from 'rxjs'
import { selectAppComponentModel } from './store/selectors/selectors'
import { HeaderComponentModel } from './ui/shared/header/header.component'
import { session_timer_reset } from 'ng-client-auth'
import { UpdateService } from 'common-services'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'

ModuleRegistry.registerModules([AllCommunityModule])

export interface AppComponentModel {
  header: HeaderComponentModel
  isAuthenticated: boolean
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent implements OnInit {
  nomenu = false
  model$: Observable<AppComponentModel>

  constructor(private store: Store<AppState>, private sw: UpdateService) {
    this.sw.checkForUpdates()
    this.model$ = this.store.pipe(select(selectAppComponentModel))
  }

  ngOnInit(): void {
    this.store.dispatch(session_timer_reset())
  }
}
